import { render, staticRenderFns } from "./ProductsOutofstock.vue?vue&type=template&id=bea9df86&"
import script from "./ProductsOutofstock.vue?vue&type=script&lang=js&"
export * from "./ProductsOutofstock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports